import { Col, Form, Input, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { httpGet } from '../../../utils/api/fetchApi';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import getList from '../../universal/getList';
const { TextArea } = Input;

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const SmsManageEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    /** 后端数据wmService */
    let wmService: any = "";
    const [smsConfigData, setSmsConfigData] = useState<any>();
    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };
    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        const fetchData = async () => {

            httpGet(wmService, {
                apiId: "smsConfig",
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {

                    setSmsConfigData(res.data)
                }
            })


        };
        fetchData();
    }, []);
    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'smsManage',
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '短信管理'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={800}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                   onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>
                    <Row >
                        <Col span={8}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>

                        </Col>

                        <Col span={8}>
                            <Form.Item
                                label="短信配置"
                                name="smsConfigId"
                                rules={[{ message: '请选择短信配置!', required: false }]}>
                                <Select
                                    showSearch
                                    placeholder="选择短信配置"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(smsConfigData, 'configName')}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label="手机号码"
                                name="phones"
                                rules={[{ message: '请输入手机号码!', required: true }]}
                            >
                                <Input />
                            </Form.Item>

                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label="发送内容"
                                name="content"
                                rules={[{ message: '请输入发送内容!', required: true }]}
                            >
                                <TextArea
                                    placeholder="发送内容"
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="发送状态"
                                name="isSend"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="已发"
                                    unCheckedChildren="未发" />
                            </Form.Item>
                        </Col>

                        <Col span={5}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default SmsManageEdit;